import React from 'react'
import './Footer.css'
import footer_logo from '../Assets/logo.png'
import instagram_icon from '../Assets/instagram_icon.png'
import facebook from '../Assets/facebook.png'
import whatsapp_icon from '../Assets/whatsapp_icon.png'

const Footer = () => {
  return (
    <div className='footer'>
        <div className="footer-logo">
            <img src={footer_logo} alt="" />
        </div>
        <ul className='footer-links'>
            <li>Company</li>
            <li>Products</li>
            <li>Offices</li>
            <li>About</li>
            <li>Contact</li>
        </ul>
        <div className="footer-social-icons">
            <div className="footer-icons-container">
               <a href="https://www.instagram.com/the_emre_officials?igsh=OG11MmdvOGx0enJw" target='_blank'><img src= {instagram_icon} alt="" /></a> 
            </div>
            <div className="footer-icons-container">
              <a href="https://www.facebook.com/share/18HbVn3RAi/" target='_blank'><img src= {facebook} alt="" /></a>  
            </div>
            <div className="footer-icons-container">
            <div  onClick = {()=> window.open(`https://wa.me/923203218800?text = Hello, can you provide more information about this product?`, '_blank')}> <h3><img src= {whatsapp_icon} alt="" /></h3> </div>

            </div>
        </div>
        <div className="footer-copyright">
            <hr />
            <p > Copyright @ 2025- All Right Reserved</p>
        </div>
    </div> 
)
}

export default Footer